module.exports = __webpack_public_path__ + "mygirlfriday.png?0ba8e06c0c7f04df7c3510c2e12f977e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/mygirlfriday.png
// module id = 124
// module chunks = 0